module.exports = __webpack_public_path__ + "contact.ef479349dc66d7bc0c9a.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Angular/projetos/RetycargasOfficialSite/src/assets/images/backgrounds/contact.jpg
// module id = ../../../../../src/assets/images/backgrounds/contact.jpg
// module chunks = styles